import { PureComponent } from "react";

import { BTUserGroup } from "commonComponents/btWrappers/BTUserGroup/BTUserGroup";
import { type IUser } from "commonComponents/utilities/Grid/common/columnImplementations/columnUser";
import { type IGridCellRenderProps } from "commonComponents/utilities/Grid/Grid.types";
import {
    type GridColumn,
    GridColumnType,
    type IClientGridColumn,
} from "commonComponents/utilities/Grid/GridContainer.types";

type UsersCellType = IUser[] | undefined;

class UsersCell extends PureComponent<
    IGridCellRenderProps<UsersCellType, GridColumn<UsersCellType>>
> {
    render() {
        const { cellValue } = this.props;

        if (!cellValue) {
            return null;
        }

        return (
            <BTUserGroup
                size="small"
                data={cellValue.map((i) => ({ globalUserId: i.id, displayName: i.displayName }))}
            />
        );
    }
}

export const columnUsers: IClientGridColumn<UsersCellType> = {
    columnType: GridColumnType.users,
    Cell: UsersCell,
};
